<template>
  <div>
    <b-container>
      <b-row class="justify-content-center">
        <b-col md="10">
          <h1>Logitech Room Configurator</h1>
          <h2>Vue.js Application</h2>
          <p>At the heart of every productive video meeting is a thoughtfully designed meeting space. My team and I developed this web application that allows users to tell Logitech about their space and how they plan to use it. The application helps the user find a tailored solution for more effective and engaging video meetings.</p>
          
          <b-button variant="primary" href="http://create-your-space.logitech.com" target="_blank">
            Visit Website <font-awesome-icon icon="external-link-alt" class="ml-2" />
          </b-button>
        </b-col>
      </b-row>

      <b-row class="mt-3 mt-lg-0">
        <b-col lg="6">
          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/lrc-home.png')"
            :srcset="require('../../assets/screens/lrc-home@2x.png') + ' 2x'" />

          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/lrc-space.png')"
            :srcset="require('../../assets/screens/lrc-space@2x.png') + ' 2x'" />
        </b-col>

        <b-col lg="6">
          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/lrc-form.png')"
            :srcset="require('../../assets/screens/lrc-form@2x.png') + ' 2x'" />

          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/lrc-recommendation.png')"
            :srcset="require('../../assets/screens/lrc-recommendation@2x.png') + ' 2x'" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      titleTemplate: 'Logitech Room Configurator | %s',
    }
  }
</script>
